import React from 'react'

import {valuesType} from 'utils/values'

import {Field, FieldProps} from '../../../components/Field'


export function NumberField({
  calculate,
  ...props
}: {
  calculate: (values: valuesType) => void,
} & FieldProps) {

  return <Field
    {...props}
    calculate={calculate}
    sx={{
      '& .MuiInputBase-root': {
        // backgroundColor: lightColorScheme.bg,
        borderRadius: '6px',
        // color: lightColorScheme.textAccent,
      },
      '& .MuiInputAdornment-root p': {
        // color: lightColorScheme.textAccent,
      },
      ...props.sx,
    }}
  />
}